import type { Message } from '@analytical-alley/opt-wasm';

// core_optimizer 3.2.x hits its SLSQP iteration limit on a cold start with a fixed channel and reports
// code 1009 while still returning a complete plan; hidden on the first run only until the optimiser
// seeds its initial guess (see spec §9). Later runs warm-start and never produce it.
export const COLD_START_ITERATION_LIMIT_CODE = '1009';

export const withoutColdStartNoise = (messages: Message[], { isFirstRun }: { isFirstRun: boolean }): Message[] =>
    isFirstRun ? messages.filter((message) => message.code !== COLD_START_ITERATION_LIMIT_CODE) : messages;
